module.exports = __webpack_public_path__ + "media/components/assets/images/cooingklePackage/image7-b5d646952efe602c1ea95629302b6f42.png";